<template>
    <footer class="footer px-4">
    </footer>
</template>
<script>
export default {
};
</script>
<style></style>
